class CartAnnouncementRotator extends HTMLElement {
  #timer;

  connectedCallback() {
    this.#start();
  }

  disconnectedCallback() {
    this.#stop();
  }

  get #slides() {
    return Array.from(this.querySelectorAll('.cart-offer-announcement__slide'));
  }

  #start() {
    this.#stop();
    if (this.#slides.length < 2) return;

    const seconds = parseFloat(this.dataset.interval || '4');
    const delay = Math.max(2, Number.isFinite(seconds) ? seconds : 4) * 1000;

    this.#timer = window.setInterval(() => this.#next(), delay);
  }

  #stop() {
    if (this.#timer) {
      window.clearInterval(this.#timer);
      this.#timer = undefined;
    }
  }

  #next() {
    if (document.hidden) return;

    const slides = this.#slides;
    if (slides.length < 2) return;

    let currentIndex = slides.findIndex((s) => s.classList.contains('is-active'));
    if (currentIndex === -1) currentIndex = 0;

    const current = slides[currentIndex];
    const next = slides[(currentIndex + 1) % slides.length];

    slides.forEach((s) => {
      if (s !== current) s.classList.remove('is-leaving');
    });

    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    current.setAttribute('aria-hidden', 'true');

    next.classList.add('is-active');
    next.removeAttribute('aria-hidden');

    const cleanup = () => current.classList.remove('is-leaving');
    current.addEventListener('transitionend', cleanup, { once: true });
    window.setTimeout(cleanup, 700);
  }
}

if (!customElements.get('cart-announcement-rotator')) {
  customElements.define('cart-announcement-rotator', CartAnnouncementRotator);
}